import { useEffect } from "react";
import Header from "@/components/Header";
import FiestaGallery from "@/components/FiestaGallery";
import Footer from "@/components/Footer";
import ScrollTop from "@/components/ScrollTop";
import FrancisConnectWidget from "@/components/FrancisConnectWidget";

export default function Fiesta() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "8th Patronal Fiesta · Saint Francis of Assisi Parish";
  }, []);
  return (
    <div className="bg-parchment-100" data-testid="fiesta-page">
      <Header />
      <main>
        <FiestaGallery />
      </main>
      <Footer />
      <ScrollTop />
      <FrancisConnectWidget />
    </div>
  );
}
